
const state = {
  bookFilename: '',
  bookTitle: '',
  contents: null,
  chapterTitle: '',
  chapterMap: '',
  chapterHeading: '',
  componentKey: 1,
  isTOCshown: true,
  sectionContent: null,
  skillSelected: null,
  bookBanner: ''
}

const getters = {

}

const mutations = {
  SET_BOOK_FILENAME: (state, payload) => {
    state.bookFilename = payload
  },
  SET_BOOK_TITLE: (state, payload) => {
    state.bookTitle = payload
  },
  SET_CONTENTS: (state, payload) => {
    state.contents = payload
  },
  SET_CHAPTER_TITLE: (state, payload) => {
    state.chapterTitle = payload
  },
  SET_CHAPTER_MAP: (state, payload) => {
    state.chapterMap = payload
  },
  SET_CHAPTER_HEADING: (state, payload) => {
    state.chapterHeading = payload
  },
  SET_COMPONENT_KEY: (state) => {
    state.componentKey++
  },
  SET_SECTION_CONTENT: (state, payload) => {
    state.sectionContent = payload
  },
  SET_SKILL_SELECTED: (state, payload) => {
    state.skillSelected = payload
  },
  SET_BOOK_BANNER: (state, payload) => {
    state.bookBanner = payload
  }
}

const actions = {
  GET_CHAPTER_MAP: ({ commit, state }) => {
    if (!state.contents) {
      let chapMap = new Map()
      let bookPath = ''
      const isProofingEnabled = process.env.VUE_APP_IS_PROOFING_ENABLED

      if (window.location.hostname.includes('localhost')) {
        bookPath = '/assets/' + state.bookFilename + '.xml'
      } else if (window.location.pathname.startsWith('/proofing') &&
                isProofingEnabled === 'true') {
        bookPath = `/proofing/titles/${state.bookFilename}/${state.bookFilename}.xml`
      } else {
        bookPath = `/titles/${state.bookFilename}/${state.bookFilename}.xml`
      }

      axios.get(bookPath).then(response => {
        let xml2js = require('xml2js')
        let parser = new xml2js.Parser()
        let xml = response.data
        parser.parseString(xml, (err, result) => {
          if (err) {
            console.log(err)
            return
          }
          let title = result.Product.ProductName[0]
          commit('SET_BOOK_TITLE', title)

          if (result.Product.ProductBanner) {
            commit('SET_BOOK_BANNER', result.Product.ProductBanner[0])
          } else {
            commit('SET_BOOK_BANNER', '/img/maths_background.png')
          }

          let chapterCount = result.Product.Chapter.length
          let chapterArray = result.Product.Chapter
          let user = {}
          user.chapterProgress = {}

          if (chapterCount == null) {
            chapMap.set(chapterArray.ChapterName, chapterArray)
            let chapArray = [chapterArray]
            user.chapterProgress[chapterArray.ChapterName] = {}
            commit('SET_CONTENTS', chapArray)
          } else {
            commit('SET_CONTENTS', chapterArray)
            for (var i = 0; i < chapterCount; i++) {
              chapMap.set(chapterArray[i].ChapterName, chapterArray[i])
              user.chapterProgress[chapterArray[i].ChapterName] = {}
            }
          }
          commit('SET_CHAPTER_MAP', chapMap)
          commit('user/setUser', user, { root: true })
        })
      })
    }
  },
  INCREMENT_COMPONENT_KEY: ({ commit }) => {
    commit('SET_COMPONENT_KEY')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
